import React from "react";
import { Modal } from "antd";
import {
  FileTextFilled,
  FileDoneOutlined,
  SplitCellsOutlined,
  EditFilled,
  TeamOutlined,
  SwapOutlined,
  ArrowRightOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

const actions = [
  { key: "INVOICE", label: "Bill Receipt", icon: <FileTextFilled /> },
  // { key: "KITCHEN_SLIP", label: "Kitchen Slip", icon: <FileDoneOutlined /> },
  { key: "SPLIT_BILL", label: "Split Bill", icon: <SplitCellsOutlined /> },
  // { key: "edit", label: "Edit Order", icon: <EditFilled /> },
  { key: "GUESTS_INPUT", label: "Guests", icon: <TeamOutlined /> },
  { key: "MERGE_ORDER", label: "Merge Orders", icon: <SwapOutlined /> },
  { key: "TRANSFER_ORDER", label: "Transfer Table", icon: <ArrowRightOutlined /> },
  { key: "CANCEL_ORDER", label: "Cancel Order", icon: <CloseCircleOutlined /> },
];

const ActionModal = ({ open, setIsOpenModal, selectedAction, onClickActionModalButton }) => {
  
  return (
    <Modal
      open={open}
      onCancel={setIsOpenModal}
      footer={null}
      centered
      width={520}
      title="Action"
      // Change 1: Added color 'black' to the close icon style
      closeIcon={
        <CloseCircleOutlined style={{ fontSize: "18px", color: "black" }} />
      }
      styles={{
        content: {
          borderRadius: "12px",
          overflow: "hidden",
          padding: 0,
        },
        header: {
          padding: "16px 24px",
          margin: 0,
          borderBottom: "1px solid #f0f0f0",
          // Change 2: Set background color as requested
          backgroundColor: "#0000001A",
        },
        body: {
          padding: "24px",
          backgroundColor: "white",
        },
      }}
    >
      <div className="grid grid-cols-3 gap-5 justify-items-center">
        {actions.map((action) => (
          <button
            key={action.key}
            onClick={() => onClickActionModalButton(action.key)}
            className={`w-[140px] h-[100px] rounded-lg flex flex-col items-center justify-center gap-2 
              shadow-sm transition-all bg-[#FFFBE4] border-1 shadow-[0px_3px_6px_#00000029]
              ${
              selectedAction === action.key
                ? "bg-red-500 text-white"
                : "bg-[#FFFCEB] hover:bg-yellow-100 text-gray-800"
            }`}
          >
            <div
              className={`text-2xl ${
                selectedAction === action.key ? "text-white" : "text-gray-800"
              }`}
            >
              {action.icon}
            </div>
            <div
              className={`font-bold text-[14px] ${
                selectedAction === action.key ? "text-white" : "text-gray-800"
              }`}
            >
              {action.label}
            </div>
          </button>
        ))}
      </div>
    </Modal>
  );
};

export default ActionModal;
